import { render, staticRenderFns } from "./ClinicTag.vue?vue&type=template&id=efd4e984&scoped=true&"
import script from "./ClinicTag.vue?vue&type=script&lang=js&"
export * from "./ClinicTag.vue?vue&type=script&lang=js&"
import style0 from "./ClinicTag.vue?vue&type=style&index=0&id=efd4e984&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd4e984",
  null
  
)

export default component.exports